import { render, staticRenderFns } from "./cartDetails.vue?vue&type=template&id=33156b8c&scoped=true&"
import script from "./cartDetails.vue?vue&type=script&lang=js&"
export * from "./cartDetails.vue?vue&type=script&lang=js&"
import style0 from "./cartDetails.vue?vue&type=style&index=0&id=33156b8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33156b8c",
  null
  
)

export default component.exports